module.exports = __webpack_public_path__ + "static/media/client-logo-17.62ca2c6d.jpg";